"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAuthCookies = exports.setAuthCookies = exports.handleRedirectCallback = exports.generateUserAuthData = exports.fetchUserInfoData = exports.fetchUserCheckoutDataWithPopup = exports.fetchUserCheckoutDataWithRedirect = exports.cookiesOption = void 0;
/* eslint @typescript-eslint/no-explicit-any: 1 */
const auth0_spa_js_1 = __importDefault(require("@auth0/auth0-spa-js"));
const fluture_1 = require("fluture");
const isomorphic_fetch_1 = __importDefault(require("isomorphic-fetch"));
const monet_1 = require("monet");
const path_1 = __importDefault(require("ramda/src/path"));
const prop_1 = __importDefault(require("ramda/src/prop"));
const cookies_1 = require("../cookies");
const initialize_1 = __importDefault(require("../cookies/initialize"));
const yoda_1 = require("../secrets/yoda");
const errorLogging_1 = require("../thirdparty/errorLogging");
const fluture_utils_1 = require("../utils/fluture-utils");
exports.cookiesOption = {
    path: '/',
    sameSite: 'strict',
    secure: true
};
const fetchUserCheckoutDataWithRedirect = (deviceId, authRedirectUri) => (handleFailure) => (handleSuccess) => yodaAuthWithRedirect(deviceId, authRedirectUri)
    .pipe((0, fluture_1.chain)(userAuthData => fetchUserPaymentData(userAuthData)
    .pipe((0, fluture_1.chain)((paymentMethods) => fetchUserAddressData(userAuthData)
    .pipe((0, fluture_1.map)((userAddresses) => {
    const userCheckoutData = {
        accessToken: userAuthData.accessToken,
        addresses: userAddresses,
        emailAddress: userAuthData.emailAddress,
        id: userAuthData.id,
        paymentMethods: paymentMethods
    };
    return monet_1.Maybe.of(userCheckoutData);
}))))))
    .pipe((0, fluture_1.fork)((e) => {
    (0, errorLogging_1.logError)(e);
    handleFailure && handleFailure(e);
})(handleSuccess));
exports.fetchUserCheckoutDataWithRedirect = fetchUserCheckoutDataWithRedirect;
const fetchUserCheckoutDataWithPopup = (deviceId) => (handleFailure) => (handleSuccess) => yodaAuthWithPopup(deviceId)
    .pipe((0, fluture_1.chain)(userAuthData => fetchUserPaymentData(userAuthData)
    .pipe((0, fluture_1.chain)(paymentMethods => fetchUserAddressData(userAuthData)
    .pipe((0, fluture_1.map)((userAddresses) => {
    const { id, accessToken, emailAddress } = userAuthData;
    (0, exports.setAuthCookies)(id, accessToken, emailAddress);
    const userCheckoutData = {
        accessToken: accessToken,
        addresses: userAddresses,
        emailAddress: userAuthData.emailAddress,
        id: id,
        paymentMethods: paymentMethods,
    };
    return monet_1.Maybe.of(userCheckoutData);
}))))))
    .pipe((0, fluture_1.fork)((e) => {
    (0, errorLogging_1.logError)(e);
    handleFailure && handleFailure(e);
})(handleSuccess));
exports.fetchUserCheckoutDataWithPopup = fetchUserCheckoutDataWithPopup;
const fetchUserInfoData = () => {
    const userCookies = (0, exports.getAuthCookies)();
    return (handleFailure) => (handleSuccess) => fetchUserAddressData(userCookies)
        .pipe((0, fluture_1.chain)(userAddresses => fetchUserProfileData(userCookies)
        .pipe((0, fluture_1.map)((userProfile) => {
        const email = (0, path_1.default)(['user', 'email'], userProfile);
        const userCheckoutData = {
            accessToken: '',
            addresses: userAddresses,
            emailAddress: email,
            id: '',
            paymentMethods: []
        };
        return monet_1.Maybe.of(userCheckoutData);
    }))))
        .pipe((0, fluture_1.fork)((e) => {
        (0, errorLogging_1.logError)(e);
        handleFailure && handleFailure(e);
    })(handleSuccess));
};
exports.fetchUserInfoData = fetchUserInfoData;
/*
 YODA
 */
const fetchUserAddressData = (userAuthData) => {
    const fetchOptions = buildFetchOptions(userAuthData.accessToken);
    return (0, fluture_1.attemptP)(() => (0, isomorphic_fetch_1.default)(`${yoda_1.userUrl}/${userAuthData.id}/addresses`, fetchOptions))
        .pipe(fluture_utils_1.verifyResponse)
        .pipe((0, fluture_1.chain)(fluture_utils_1.attemptBody));
};
const fetchUserProfileData = (userAuthData) => {
    const fetchOptions = buildFetchOptions(userAuthData.accessToken);
    return (0, fluture_1.attemptP)(() => (0, isomorphic_fetch_1.default)(`${yoda_1.userUrl}/${userAuthData.id}`, fetchOptions))
        .pipe(fluture_utils_1.verifyResponse)
        .pipe((0, fluture_1.chain)(fluture_utils_1.attemptBody));
};
const fetchUserPaymentData = (userAuthData) => {
    const fetchOptions = buildFetchOptions(userAuthData.accessToken);
    return (0, fluture_1.attemptP)(() => (0, isomorphic_fetch_1.default)(`${yoda_1.userUrl}/${userAuthData.id}/paymentMethods`, fetchOptions))
        .pipe(fluture_utils_1.verifyResponse)
        .pipe((0, fluture_1.chain)(fluture_utils_1.attemptBody));
};
const buildFetchOptions = (token) => {
    return {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        method: 'GET'
    };
};
const generateUserAuthData = (accessToken, user) => {
    return {
        accessToken: accessToken,
        emailAddress: monet_1.Maybe.fromUndefined(user).cata(() => '', user => (0, prop_1.default)('email', user) || ''),
        id: monet_1.Maybe.fromUndefined(user).cata(() => '', user => (0, prop_1.default)('http://simplisafe.com/uid', user) || '')
    };
};
exports.generateUserAuthData = generateUserAuthData;
const getUserAuthData = (client) => (0, fluture_1.attemptP)(() => client.getTokenSilently())
    .pipe((0, fluture_1.both)((0, fluture_1.attemptP)(() => client.getUser())))
    .pipe((0, fluture_1.map)(([user, accessToken]) => (0, exports.generateUserAuthData)(accessToken, user)));
/*
 AUTH WITH REDIRECT
 */
const clientFutureWithRedirect = (deviceId, redirectUri) => (0, fluture_1.attemptP)(() => (0, auth0_spa_js_1.default)({
    audience: yoda_1.authAudience,
    'client_id': yoda_1.authClientId,
    'device_id': deviceId,
    domain: yoda_1.authDomain,
    'redirect_uri': redirectUri,
    scope: yoda_1.authScope
}));
const yodaAuthWithRedirect = (deviceId, redirectUri) => clientFutureWithRedirect(deviceId, redirectUri)
    .pipe((0, fluture_1.chain)(loginAndGetUserInfoWithRedirect));
const loginAndGetUserInfoWithRedirect = (client) => (0, fluture_1.attemptP)(() => client.loginWithRedirect())
    .pipe((0, fluture_1.and)(getUserAuthData(client)));
const handleRedirectCallback = (deviceId, redirectUri) => (handleFailure) => (handleSuccess) => clientFutureWithRedirect(deviceId, redirectUri)
    .pipe((0, fluture_1.chain)(client => ((0, fluture_1.attemptP)(() => client.handleRedirectCallback())
    .pipe((0, fluture_1.chain)(() => getUserAuthData(client))))))
    .pipe((0, fluture_1.fork)((e) => {
    (0, errorLogging_1.logError)(e);
    handleFailure(e);
})(handleSuccess));
exports.handleRedirectCallback = handleRedirectCallback;
/*
 AUTH WITH POPUP
 */
const clientFuture = (deviceId) => (0, fluture_1.attemptP)(() => (0, auth0_spa_js_1.default)({
    audience: yoda_1.authAudience,
    'client_id': yoda_1.authClientId,
    'device_id': deviceId,
    domain: yoda_1.authDomain,
    scope: yoda_1.authScope
}));
const yodaAuthWithPopup = (deviceId) => clientFuture(deviceId)
    .pipe((0, fluture_1.chain)(loginAndGetUserInfoWithPopup));
const loginAndGetUserInfoWithPopup = (client) => (0, fluture_1.attemptP)(() => client.loginWithPopup())
    .pipe((0, fluture_1.and)(getUserAuthData(client)));
/*
Cookies
*/
const setAuthCookies = (id, accessToken, emailAddress) => {
    const cookies = (0, initialize_1.default)();
    id && cookies.set(cookies_1.COOKIE_DRUPAL_UID, id, exports.cookiesOption);
    accessToken && cookies.set(cookies_1.COOKIE_USER_TOKEN, accessToken, exports.cookiesOption);
    accessToken && cookies.set(cookies_1.COOKIE_EMAIL, emailAddress, exports.cookiesOption);
};
exports.setAuthCookies = setAuthCookies;
const getAuthCookies = () => {
    const cookies = (0, initialize_1.default)();
    const userID = cookies.get(cookies_1.COOKIE_DRUPAL_UID);
    const accessToken = cookies.get(cookies_1.COOKIE_USER_TOKEN);
    return {
        accessToken: accessToken,
        emailAddress: '',
        id: userID
    };
};
exports.getAuthCookies = getAuthCookies;
//# sourceMappingURL=yodaClient.js.map